import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { SkodaLink } from '../../buttons';
import { CircularProgress } from '../../circularProgress';
import { useDynamicPercentage, useExpiryDateText, useRemainingValueText } from '../hooks';
import { WarrantyBaseProps } from '../types';

const useStyles = makeStyles({ name: 'WarrantySmall-4' })(theme => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		maxWidth: 400
	},
	title: {
		fontWeight: 700,
		fontSize: '18px',
		lineHeight: '28px',
		letterSpacing: '0.02em',
		marginBottom: 27
	},
	valuesPanel: {
		display: 'flex',
		gap: 78,
		marginBottom: 20
	},
	remainingPanel: {
		display: 'flex',
		flexDirection: 'column',
		fontSize: '18px',
		lineHeight: '28px',
		letterSpacing: '0.02em',
		fontWeight: 700
	},
	labelRemaining: {
		color: '#9E9FA0'
	},
	valueRemaining: {

	},
	panelBottom: {
		display: 'flex',
		gap: 30,
		justifyContent: 'space-between'
	},
	expiryDate: {
		fontSize: '12px',
		lineHeight: '16px',
		letterSpacing: '0.02em',
		whiteSpace: 'nowrap'
	},
	linkConditions: {
		fontWeight: 700,
		fontSize: '12px',
		lineHeight: '12px',
		textAlign: 'end',
		cursor: 'pointer'
	}
}));

export const WarrantySmall4 = (props: WarrantyBaseProps) => {
	const { translations, value, max, className, link } = props;
	const { classes, cx } = useStyles(null, { props });

	const dynamicValue = useDynamicPercentage(value, max);
	const remainingValueText = useRemainingValueText(props);
	const expiryDateText = useExpiryDateText(props);

	return (
		<div className={cx(classes.root, className)}>
			{translations.title && <span className={classes.title}>{translations.title}</span>}
			<div className={classes.valuesPanel}>
				<CircularProgress value={dynamicValue} variant='determinate' size={95} thickness={10} />
				<div className={classes.remainingPanel}>
					<span className={classes.labelRemaining}>{translations.remainingLabel}</span>
					<span className={classes.valueRemaining}>{remainingValueText}</span>
				</div>
			</div>
			{(expiryDateText || link) &&
				<div className={classes.panelBottom}>
					{expiryDateText && <span className={classes.expiryDate}>{expiryDateText}</span>}
					{link && <SkodaLink href={link} target='_blank' className={classes.linkConditions}>{translations.linkConditions}</SkodaLink>}
				</div>}
		</div>
	);
};
